import React from "react";
import { parseISO } from "date-fns";
import { localizedFormatDate } from "helpers/userLocale";

//icons
import ChatIcon from "../../assets/Icon_Chat.png";
import { GuaranteeViewData } from "./GuaranteeDataModel";
import { PopoutImage } from "./GuaranteePanelReportSummary";

type Props = {
  details: GuaranteeViewData;
  report:boolean;
};

const GuaranteePanelClientProfile: React.FC<Props> = ({ details, report=false }) => {
  return (
    <div className={`ClientProfile ${report?'increase-font':''}`}>
      {report?<h2>Profile</h2>:<h4>Profile</h4>}
      <div className="ClientProfileHeader">
        {details.livePhotoImageURI && (
          <PopoutImage
            url={details.livePhotoImageURI}
            className="updated-ProfileImage"
          />
        )}
        <div className="RightContainer">
          <p>
            <b>{`${details.firstName} ${details.lastName}`}</b>
          </p>
          <p>
            {details.document?.dateOfBirth
              ? localizedFormatDate(parseISO(details.document.dateOfBirth))
              : ""}
          </p>
        </div>
      </div>
      <table className="ViewTable">
        <thead>
          <tr>
            <th>Info type</th>
            <th>Details</th>
            {/* <th>Status</th> */}
            {/* <th>&nbsp;</th> */}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Given names</td>
            <td>{details.verifiedGivenNames ?? "-"}</td>
            {/* <td>&nbsp;</td> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
          <tr>
            <td>Surnames</td>
            <td>{details.verifiedLastName ?? "-"}</td>
            {/* <td>&nbsp;</td> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
          <tr>
            <td>Age</td>
            <td>{details.document?.age ?? "-"}</td>
            {/* <td>&nbsp;</td> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
          {details.nationality && (
            <tr>
              <td>Nationality</td>
              <td>{details.nationality}</td>
              {/* <td>&nbsp;</td> */}
              {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default GuaranteePanelClientProfile;
